
import Vue from "vue";
import {Component, Prop, Ref} from "vue-property-decorator";
import EqifyTable from "@/components/table/EqifyTable.vue";
import DeleteButton from "@/components/general/buttons/DeleteButton.vue";
import EditButton from "@/components/general/buttons/EditButton.vue";
import EqifyRuleBuilder from "@/components/rules/EqifyRuleBuilder.vue";
import LoadingButton from "@/components/general/buttons/LoadingButton.vue";
import {EqifyCrudUtils} from "@/components/crud/EqifyCrudComponent.vue";
import EqifyRuleViewer from "@/components/rules/viewer/EqifyRuleViewer.vue";
import EqifyRuleGroupViewer from "@/components/rules/viewer/EqifyRuleGroupViewer.vue";
import EqifyDataLoader from "@/components/EqifyDataLoader.vue";
import {
  CompetitionRegistrationActionDefinition,
  CompetitionRegistrationActionType
} from "@/shared/domain/CompetitionRegistrationAction";
import {BModal} from "bootstrap-vue";

@Component({
  components: {
    EqifyDataLoader,
    EqifyRuleGroupViewer,
    EqifyTable, EditButton, DeleteButton, EqifyRuleBuilder, LoadingButton, EqifyRuleViewer
  }
})
export default class CompetitionRegistrationActionCrudComponent extends Vue {
  @Prop({
    type: Array, default: () => {
      return []
    }
  }) value!: Array<CompetitionRegistrationActionDefinition>;
  @Prop() federationRef?: string
  @Ref("crudModal")
  modal!: BModal

  private fields: Array<any> = [];
  private isEdit = false
  private form: Form = this.newForm();
  private crudFormSchema = {}
  private formValid: boolean = false;
  private formOptions = {
    validateAfterLoad: true,
    validateAfterChanged: true
  };

  created() {
    this.$loader.load(async () => {
      await this.fetchFormMetaData()
      this.fields = [
        {
          key: 'order',
          label: 'Volgorde'
        },
        {
          key: 'condition',
          label: 'Voorwaarde'
        },
        {
          key: 'action',
          label: 'Actie'
        },
        EqifyCrudUtils.actions(this)
      ]

      this.crudFormSchema = {
        fields: [
          {
            type: 'eqifyRuleBuilder',
            model: 'condition',
            label: "Voorwaarde",
            federationRef: this.federationRef,
            required: false
          },
          {
            type: 'vueSelect',
            model: 'action',
            label: "Actie",
            required: false
          }
        ]
      }
    }, "price-profile-crud-metadata-loader")
  }

  onDelete(row: any) {
    let action = row.item;
    this.value.splice(this.value.indexOf(action), 1)
    let n = 0
    this.value.forEach(it => it.order = n++)
    this.$emit("delete", action)
  }

  openEditModal(row: any) {
    this.isEdit = true
    this.form = /*{...row.item}*/ this.newForm()

    this.form = {
      order: row.item.order,
      condition: row.item.condition,
      action: row.item.action,
    }

    this.modal.show()
  }

  openCreateModal() {
    this.isEdit = false
    this.form = this.newForm()
    this.form.order = this.value.length
    this.modal.show()
  }

  async fetchFormMetaData() {

  }

  save() {
    if (this.isEdit) {
      this.onEdit()
    } else {
      this.onCreate()
    }
  }

  onEdit() {
    const action = this.createAction()
    const index = this.value.findIndex(it => it.order == this.form.order)
    this.$set(this.value, index, action)
    this.modal.hide()
  }

  private createAction(): CompetitionRegistrationActionDefinition {
    return {
      order: this.form.order,
      condition: this.form.condition,
      action: this.form.action
    } as CompetitionRegistrationActionDefinition
  }

  onCreate() {
    const action = this.createAction()
    this.value.push(action)
    this.modal.hide()
  }

  newForm(): Form {
    return {
      order: this.value.length,
      condition: undefined,
      action: undefined
    }
  }

  formValidated(isValid: boolean, errors: Array<string>) {
    this.formValid = isValid;
  }
}

export interface Form {
  order: number,
  condition?: Object,
  action?: CompetitionRegistrationActionType
}

